import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function UndoIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M16.5 9H5.55585L9.67871 5.19043L8.32129 3.72168L1.52637 10L8.32129 16.2783L9.67871 14.8096L5.55585 11H16.5C18.4297 11 20 12.5703 20 14.5C20 16.4297 18.4297 18 16.5 18H14V20H16.5C19.5322 20 22 17.5322 22 14.5C22 11.4678 19.5322 9 16.5 9Z",
    fill: "currentColor"
  }));
}